import { Platform } from "react-native";
// prevents FastImage from crashing when Url is not valid or path inaccessible (especially on Android)

const normalizeSource = source => {
  if (Platform.OS === "ios" || Platform.OS === "web") return source;

  const normalizedSource =
    source &&
    typeof source === "string" &&
    !source.split("http")[1] &&
    !source.split("file://")[1] &&
    !source.split("content://")[1]
      ? null
      : source;

  return normalizedSource;
};

export default normalizeSource;
